<script setup>
import { defineProps, defineEmits} from "vue";
import HeaderDeAditivos from "./HeaderDeAditivos.vue";
import BodyDeAditivos from "./BodyDeAditivos.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraAditivo",
]);

//==================================================================//
//======================= Altera Aditivo ===========================//
//==================================================================//

const alteraAditivo = (update) =>{
    
    emits('update:alteraAditivo',update);

};

</script>

<template>

    <v-card>

        <v-card-title class="c-aditivos">

            <h3 class="c-aditivos__titulo">

                Aditivos

            </h3>

        </v-card-title>

        <div class="c-table-wrapper">

            <div class="c-table">

                <HeaderDeAditivos
                    :dado="props.dado"
                ></HeaderDeAditivos>
                
                <BodyDeAditivos
                    :dado="props.dado"
                    @update:alteraAditivo="alteraAditivo"
                ></BodyDeAditivos>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-aditivos{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-aditivos__titulo {
    grid-area: titulo;
}

.c-table-wrapper{
    overflow: hidden !important;
    width: calc(100vw - 24px);
    padding: 12px !important;
}

.c-table{
    display: grid;
    grid-template-columns: max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

</style>